import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  root:{
    marginTop: '40px'
  },
  title: {
    color: theme.palette.black.dark,
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: '130%',
    marginBottom: '20px'
  },
  inputWrapper: {
    display: 'flex',
    flexDirection: 'column',
    width: "297px",
  },
  item: {
    marginBottom: '22px'
  },
  formLabel: {
    fontSize: '14px',
    fontWeight: 600,
    color: theme.palette.grey.grey500,
    whiteSpace:'nowrap'
  },
  textField: {
    marginTop: "8px",
    "& .MuiOutlinedInput-root": {
      background: 'white',
      border: 0,
    }
  },
  textFieldError: {
    "& .MuiOutlinedInput-root": {
      color: "red",
    }
  },
  firstBlock: {
    display: 'flex',
    alignItems: 'center',
    justifyContent:'space-between',
    marginTop: '19px',
    '> :nth-child(2)': {
      marginLeft: '15px',
      marginRight: '15px'
    }
  },
}));

export default useStyles;
